export const VERSION = '6.4.0' as const;
